<template>
  <div class="base-card mb-3">
    <div
      class="card-body"
      :class="{'base-card-body--dense': dense}"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
    name: 'BaseCard',
    props: {
        dense: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss">
  .base-card{
    background: white;
    // border: 1px solid #E3E3E3;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(black, 0.05);
  }
  .base-card-body--dense{
    padding: 0.875rem !important;
  }
</style>
